import { getCurrentInstance } from 'vue'

/**
 * Use the current instance router.
 */
export function useRouter() {
    const instance = getCurrentInstance()

    if (!instance) {
        throw new Error('No Vue instance available.')
    }

    return instance.appContext.config.globalProperties.router
}
